import { EditFileModalForm } from "./EditFileModalForm"


const EditFileModalFormWrapper = () => {
    return (<EditFileModalForm />)
}

export {EditFileModalFormWrapper}